import React from "react";
import { motion } from "framer-motion";
import { INDUSTRIES } from "@/data/site";
import { SectionHeading } from "@/components/pp/Shared";

const COLORS = ["#f59e0b", "#ec4899", "#8b5cf6", "#3b82f6", "#06b6d4"];

export default function Industries() {
  return (
    <section id="solutions" className="relative py-24 md:py-32" data-testid="solutions">
      <div className="pp-container">
        <SectionHeading overline="Industries" title="Creative Solutions Across Industries"
          sub="Tailored creative and marketing systems for the sectors we know best." testid="industries-heading" />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {INDUSTRIES.map((ind, i) => (
            <motion.div key={ind}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
              whileHover={{ rotateY: 8, rotateX: -6, y: -6 }}
              style={{ transformStyle: "preserve-3d", perspective: 900 }}
              className="group relative pp-card rounded-xl p-6 min-h-[130px] flex flex-col justify-between overflow-hidden"
              data-testid={`industry-${ind.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}
            >
              <span className="absolute -right-6 -top-6 h-16 w-16 rounded-full blur-2xl opacity-40 group-hover:opacity-70 transition-opacity"
                style={{ background: COLORS[i % COLORS.length] }} />
              <span className="font-display text-3xl text-white/10 group-hover:text-white/25 transition-colors">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-display uppercase text-lg leading-tight text-white">{ind}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
